import { graphql, useMutation } from "react-relay";
import { useToast } from "src/hooks/use-toast";

import { useInterruptAgentMutationInterruptAgentMutation } from "./__generated__/useInterruptAgentMutationInterruptAgentMutation.graphql";

// Mutation for interrupting the agent's thought process
const interruptAgentMutation = graphql`
  mutation useInterruptAgentMutationInterruptAgentMutation($input: InterruptAgentInput!) {
    interruptAgent(input: $input) {
      success
    }
  }
`;

export const useInterruptAgentMutation = () => {
  const { toast } = useToast();
  const [commitInterruptAgent, isInFlight] = useMutation<useInterruptAgentMutationInterruptAgentMutation>(interruptAgentMutation);

  const handleInterruptAgent = (conversationId: string, _messageId?: string, llmConversationId?: string, llmInteractionId?: string) => {
    void _messageId;
    void conversationId; // No longer used but kept for backward compatibility
    commitInterruptAgent({
      variables: {
        input: {
          llmConversationId: llmConversationId!,
          llmInteractionId: llmInteractionId!,
        }
      },
      onCompleted: () => {
        // do nothing
      },
      onError: (error) => {
        toast({
          title: "Error",
          description: "Failed to interrupt agent: " + error.message,
          variant: "error",
        });
      }
    });
  };

  return {
    handleInterruptAgent,
    isInterrupting: isInFlight
  };
};
